import { render } from "./FlowInsights.vue?vue&type=template&id=3a6f3473&scoped=true"
import script from "./FlowInsights.vue?vue&type=script&lang=js"
export * from "./FlowInsights.vue?vue&type=script&lang=js"

import "./FlowInsights.vue?vue&type=style&index=0&id=3a6f3473&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6f3473"]])

export default __exports__